module.exports = __webpack_public_path__ + "img/selected7-min.f2992e3f.png";